import { createContext } from 'react'

// ----------------------------------------------------------------------
// The element a screen's loading state fills.
//
// `ContentLoading` is absolutely positioned, so without this it resolves
// against the nearest positioned ancestor — and the theme makes every `MuiCard`
// `position: relative`, so on any screen that wraps its content in a card the
// loading state was trapped inside the card and clipped by its `overflow`. On
// the analytics screen that was a 48 pixel band with a spinner squeezed into it.
//
// Naming the element removes the guess: the layout publishes its content column
// and the loading state renders into it, wherever in the tree it was written.
// Outside the layout there is no element to name and the loading state renders
// where it stands, which is correct for the screens that have no chrome.
// ----------------------------------------------------------------------

export const ContentAreaContext = createContext<HTMLElement | null>(null)

/** The attribute the screenshot sweep reads a screen's own text from. */
export const CONTENT_AREA_ATTRIBUTE = 'data-app-content'
